import { DCTaskStatus } from '@/models/doc-cirrus/DCTask.ts';

export enum ColumnType {
    EXPECTED = 'expected',
    WAITING_ROOM = 'waitingRoom',
    TREATMENT_ROOM = 'treatmentRoom',
    DISCHARGED = 'discharged',
}

export interface KanbanColumn<T extends ColumnType | DCTaskStatus, K extends { id: string }> {
    id: string;
    title: string;
    type: T;
    collapsed: boolean;
    items: K[];
    instance_id?: string;
}

export interface KanbanMove<T extends ColumnType | DCTaskStatus, K extends { id: string }> {
    item: K;
    source_column: KanbanColumn<T, K>;
    destination_column: KanbanColumn<T, K>;
}
